import React from "react";
import {fire} from '../firebase/Firebase.js';

/*** ================================================================================
 *          Parse Dates
 * ================================================================================*/
export function getDateFromMilliseconds(num) {
    const date = new Date(num);
    return date.getFullYear() + '-' + date.getMonth() + '-' + date.getUTCDate() + ' ' + date.getHours() + ':' + date.getMinutes();
}
export function getDate() {
    const date = new Date();
    return date.getFullYear() + '-' + date.getMonth() + '-' + date.getUTCDate() + ' ' + date.getHours() + ':' + date.getMinutes();
}
export function getDateInput(input) {
    if (input === undefined) {
        return "-"
    }
    try {
        const date = new Date(input);
        return date.getUTCDate() + '/' + date.getMonth() + '/' + date.getFullYear();
    } catch (e) {
        return "0"
    }

}
/*** ================================================================================
 * FIREBASE
 * ================================================================================*/
export function getCollection(collection) {
    return new Promise(function (resolve, reject) {
        fire.firestore().collection(collection).get().then(res => {
            const data = [];
            res.forEach(doc => {
                data.push({
                    idPost: doc.id,
                    ...doc.data()
                })
            });
            resolve(data)
        }).catch(err => {
            reject(err);
        });
    });
}
export function getDocInCollection(collection, id) {
    return new Promise(function (resolve, reject) {
        try {
            fire.firestore().collection(collection).doc(id)
                .get()
                .then(querySnapshot => {
                    resolve(querySnapshot.data());
                });
        } catch (e) {
            reject(e);
        }
    })
}
export function getCollectionWhereKeyValue(collection, key, value) {
    return new Promise(function (resolve, reject) {
        fire.firestore().collection(collection).where(key, "==", value).get().then(res => {
            const data = [];
            res.forEach(doc => {
                data.push({
                    idPost: doc.id,
                    ...doc.data()
                })
            });
            resolve(data)
        }).catch(err => {
            reject(err);
        });
    });
}
export function setDocumentToCollection(collection, document) {
    return new Promise(function (resolve, reject) {
        try {
            fire.firestore().collection(collection).add(document)
                .then(r => {
                    resolve({result: r});
                }).catch(e => {
                reject(e);
            })
        } catch (e) {
            reject(e);
        }
    })
}
export function updateDocumentInCollection(collection, document, idDocumnent) {
    return new Promise(function (resolve, reject) {
        try {
            fire.firestore().collection(collection).doc(idDocumnent).update(document).then(r => {
                resolve({result: r})
            }).catch(e => {
                reject(e);
            })
        } catch (e) {
            reject(e);
        }
    })
}
export function deleteDocumentFromCollectionWithID(collection, idPost) {
    return new Promise(function (resolve, reject) {
        try {
            fire.firestore().collection(collection).doc(idPost).delete()
                .then(result => {
                    resolve(result)
                }).catch(function (error) {
                reject(error)
            });
        } catch (e) {
            reject(e)
        }
    })
}
/*** ================================================================================
 * USER
 * ================================================================================*/
export function createNewUser(user) {
    return new Promise(function (resolve, reject) {
        getCollectionWhereKeyValue('users', 'uid_firebase', user.uid).then( r => {
            // console.log(r.length)
            // console.log(user.uid)
            localStorage.setItem('crypto__uid', user.uid);
            if (r.length === 0){
                setDocumentToCollection('users', {
                    uid_firebase: user.uid,
                    displayName_firebase: user.displayName,
                    email_firebase: user.email,
                    emailVerified_firebase: user.emailVerified,
                    phoneNumber_firebase: user.phoneNumber,
                    photoURL_firebase: user.photoURL,
                    favoritePairs: [],
                }).then( r => {
                    resolve(r)
                }).catch( e => {
                    reject(e)
                })
            }else {
                // console.log("ALREADY REGISTER")
            }
        }).catch( e => {
            reject(e)
        })
    });
}



